module.exports = __webpack_public_path__ + "img/logo.acda761b.png";